
/**
 * Performance observers for Web Vitals
 */
import { LayoutShiftEntry, FirstInputEntry } from './types';
import { reportMetric } from './core';

/**
 * Register performance observers to track key metrics
 */
export function registerObservers() {
  try {
    // Track layout shifts (CLS)
    if ('PerformanceObserver' in window) {
      // Layout Shifts Observer
      const clsObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        let clsScore = 0;
        
        entries.forEach((entry) => {
          // Cast to our custom interface with hadRecentInput
          const layoutShiftEntry = entry as unknown as LayoutShiftEntry;
          if (!layoutShiftEntry.hadRecentInput) {
            clsScore += layoutShiftEntry.value;
          }
        });
        
        if (clsScore > 0) {
          reportMetric('CLS', clsScore);
        }
      });
      
      clsObserver.observe({ type: 'layout-shift', buffered: true });
      
      // First Input Delay Observer
      const fidObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        entries.forEach((entry) => {
          const firstInputEntry = entry as unknown as FirstInputEntry;
          const fid = firstInputEntry.processingStart - firstInputEntry.startTime;
          reportMetric('FID', fid);
        });
      });
      
      fidObserver.observe({ type: 'first-input', buffered: true });
      
      // Largest Contentful Paint Observer
      const lcpObserver = new PerformanceObserver((entryList) => {
        const entries = entryList.getEntries();
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
          reportMetric('LCP', lastEntry.startTime);
        }
      });
      
      lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    }
  } catch (e) {
    console.error('Error setting up performance observers:', e);
  }
}
